import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/leaderboard/error.tsx");
